import { xs_isMobile } from "../..";
import { appConfig } from "../../appConfig";
import { concatUrlPathnames } from "../sport-utils";

export function getLiveMatchPathname() {
	const p = xs_isMobile?'live':'live-match';
	const base = appConfig?.ROUTES?.live?.[p];
	return xs_isMobile?concatUrlPathnames(base,'/lm'):base;
}
